import createReducer from 'common/reducerBase';
import { spliceArrayProp } from 'utils/seamlessUtils';
import WidgetDataRecord from '../data/WidgetDataRecord';
import { types } from '../actions';

const clearNotificationById = (state, id) => state.setIn(['notifications', id], null);

export default createReducer(WidgetDataRecord(), {
  [types.SET_ACTIVE_SOURCE]: (state, { payload }) => state.set('source', payload.source),

  [types.ADD_NOTIFICATION]: (state, { payload }) =>
    state.notifications[payload.notification.id] ? state : state.setIn(['notifications', payload.notification.id], payload.notification),

  [types.CLEAR_NOTIFICATION]: (state, { payload }) => clearNotificationById(state, payload.id),

  [types.SET_IS_RESPONSIVE]: (state, { payload }) => state.set('isResponsiveWidth', payload.isResponsiveWidth),

  [types.TOGGLE_ADVANCED_OPTIONS]: (state) => state.set('advancedOptionsOpen', !state.advancedOptionsOpen),

  [types.SET_ADVANCED_OPTIONS]: (state, { payload }) => state.set('advancedOptionsOpen', payload),

  [types.SET_UPLOAD_TAGS]: (state, { payload }) => state.set('advancedTags', payload.tags),

  [types.SET_UPLOAD_PRESET]: (state, { payload }) => state.set('advancedUploadPreset', payload.uploadPreset),

  [types.SET_PUBLIC_ID]: (state, { payload }) =>
    state.merge({
      advancedPublicId: payload.value,
      publicIdError: false,
    }),

  [types.CLEAR_ADVANCED_VALUES]: (state) =>
    state.merge({
      advancedPublicId: '',
      advancedTags: [],
      advancedUploadPreset: null,
      tagsInputValue: '',
      advancedOptionsOpen: false,
    }),

  [types.REMOVE_UPLOAD_TAG]: (state, { payload }) => spliceArrayProp(state, 'advancedTags', payload.index),

  [types.REMOVE_LAST_UPLOAD_TAG]: (state) => (state.advancedTags.length ? spliceArrayProp(state, 'advancedTags', state.advancedTags.length - 1) : state),

  [types.TOGGLE_RESPONSIVE_MENU]: (state, { payload }) =>
    state.set('responsiveMenuShow', payload && typeof payload.show !== 'undefined' ? payload.show : !state.responsiveMenuShow),

  [types.DO_INC_CLOSE_COUNTER]: (state) =>
    state.merge({
      widgetCloseCounter: state.widgetCloseCounter + 1,
      isShowing: false,
    }),

  [types.SET_WIDGET_SHOWING]: (state) => state.set('isShowing', true),

  [types.SET_WIDGET_VIEW_TYPE]: (state, { payload }) =>
    state.merge({
      widgetViewType: payload.type,
      widgetViewTypeChangeByUser: !!payload.userAction,
    }),

  [types.SET_SUGGESTED_TAGS]: (state, { payload }) => state.set('suggestedTags', payload.tags || []),

  [types.SET_SUGGESTED_UPLOAD_PRESETS]: (state, { payload }) => state.set('suggestedUploadPresets', ['', ...payload.uploadPresets] || []),

  [types.SET_TAGS_INPUT_VALUE]: (state, { payload }) => state.set('tagsInputValue', payload.value),

  [types.SET_INVALID_PUBLIC_ID_FOUND]: (state) =>
    state.merge({
      advancedOptionsOpen: true,
      publicIdError: true,
    }),

  [types.SET_BATCH_STARTED]: (state) => state.set('batchStartCounter', state.batchStartCounter + 1),

  [types.SET_IS_PREMIUM]: (state, { payload }) =>
    state.merge({
      premiumInfoReceived: true,
      isPremium: !!(payload.onConsole || (payload.info && payload.info['data-premium'])),
    }),

  [types.SET_SUCCESSFUL_COUNTER]: (state, { payload }) => state.set('successfulCount', payload.count),

  [types.SET_DICTIONARY_TEXT_CHANGED]: (state) => state.set('dictionaryTextVersion', state.dictionaryTextVersion + 1),

  [types.SET_LAST_PRE_QUEUE_PATH]: (state, { payload }) => state.set('preQueuePath', payload.path),

  [types.SET_METADATA_SCHEMA_DATA]: (state, { payload }) => state.set('metadataSchemaData', payload.data).set('metadataInfo', null),

  [types.SET_METADATA_INFO]: (state, { payload }) => {
    const { values, fields } = payload;

    return state.set('metadataInfo', {
      uploadFiles: state.metadataSchemaData.files,
      cropInfo: state.metadataSchemaData.cropInfo,
      conflicts: state.metadataSchemaData.conflictedFiles,
      fields,
      values,
    });
  },
  [types.SET_TABS_ROUTES]: (state, { payload }) => {
    return state.set('tabRoutes', payload.routes);
  },
});
